//SWITCH: Disables the Sojern tracking pixel
export const trackingDisabled = false;

const APP_CONFIG = {
  loadingDuration: 2500,
};

export default APP_CONFIG;
